import { Component, computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
import { HomeService } from '../../../home/home.service';
import { ParameterValueEditor } from '../../../shared/parameter-value-editor/parameter-value-editor';

@Component({
  selector: 'cmi-document-property-edit',
  imports: [ParameterValueEditor],
  templateUrl: './document-property-edit.html'
})
export class DocumentPropertyEdit {
  private readonly _route = inject(ActivatedRoute);
  private readonly _homeService = inject(HomeService);

  public readonly groupName: Signal<string> = toSignal(
    this._route.paramMap.pipe(map((params) => params.get('groupName') ?? '')),
    { initialValue: '' }
  );

  public readonly parameterType = computed((): 'text' | 'date' | 'number' | 'boolean' => {
    const rootType = this._homeService.rootType();
    const name = this.groupName();
    if (rootType) {
      for (const provider of rootType.contentProvider ?? []) {
        const parameter = (provider.parameters ?? []).find((p) => p.name === name);
        if (parameter) {
          const typeName = parameter.typeName;
          if (typeName === 'DateTime') {
            return 'date';
          }
          if (typeName === 'Boolean') {
            return 'boolean';
          }
          if (typeName === 'Number' || typeName === 'Double' || typeName === 'Int') {
            return 'number';
          }
          return 'text';
        }
      }
    }
    return 'text';
  });
}
